angular.module('components.caPurchaseOrderDistributionGrid', [])
    .component('caPurchaseOrderDistributionGrid', {
        templateUrl: 'main/order/purchaseorder/components/purchaseorderdistributiongrid.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            selectedColorVariant: '<',
            selectedArticle: '<',
            purchaseOrder: '<',
            disabled: '<',
            orderChangeCount: '<',
            onPurchaseOrderChanged: '&'
        },
        controller: controller
    });

// @ngInject    
function controller($scope, OrdersApiService, BudgetsApiService) {
    var vm = this;

    var distributionGrid = {};
    var rowData = [];
    var rowCollection = new wijmo.collections.CollectionView(rowData);

    var highlightForeGroundColor = '#000000';
    var highlightBackgroundColor = '#ffddee';
    var summaryCellBackgroundColor = '#dddddd';

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.totalQuantityToDistribute = 0;
    vm.budgets = [];
    vm.packs = [];
    vm.selectedPack = [];
    vm.locations = [];

    vm.captureDistributionGrid = captureDistributionGrid;
    vm.cellEditEnded = cellEditEnded;
    vm.distributeBudgetQuantities = distributeBudgetQuantities;
    vm.recalculateTotals = recalculateDistributionGridTotals;
    vm.getAndApplyBudget = getAndApplyBudget;

    function onInit() {
        OrdersApiService.getLocations().then(function(response) {
            vm.locations = response;
        }, function(error) {
            //toasterservice here
            console.log(error);
        });

        $scope.$watch(function() { return vm.selectedColorVariant; }, function() {
            // Check if the grid has been captured before trying to do something.
            if (distributionGrid.invalidate) {
                setupGridColumns();
                setupGridData();
                recalculateDistributionGridTotals();
                distributionGrid.invalidate();
                rowCollection.refresh();
            }
        });

        $scope.$watch(function() { return vm.selectedArticle; }, function() {
            if (vm.selectedArticle !== undefined && vm.selectedArticle.id !== undefined) {
                getArticlePacks();
            }
        });
    }

    function onChanges() {
    }

    function onDestroy() {
    }

    // Capture the distribution grid and set up its contents
    function captureDistributionGrid(s) {
        distributionGrid = s;
        distributionGrid.itemsSource = rowCollection;
        configureGridItemsFormatter();
        setupGrid();
        setupGridColumns();
        setupGridData();
    }

    // Initialize the grid
    function setupGrid() {
        rowData.length = 0;
        distributionGrid.finishEditing(true);
        distributionGrid.columns.clear();
        distributionGrid.invalidate();
        rowCollection.refresh();
    }

    // Create the grid columns
    function setupGridColumns() {
        distributionGrid.columns.clear();

        var locationColumn = new wijmo.grid.Column();
        locationColumn.binding = "locationName";
        locationColumn.header = " ";
        locationColumn.allowSorting = false;
        locationColumn.width = "2*";
        locationColumn.allowSorting = false;
        locationColumn.isReadOnly = true;
        distributionGrid.columns.push(locationColumn);

        var colorColumn = new wijmo.grid.Column();
        colorColumn.binding = "colorName";
        colorColumn.header = "  ";
        colorColumn.allowSorting = false;
        colorColumn.width = "2*";
        colorColumn.allowSorting = false;
        colorColumn.isReadOnly = true;
        distributionGrid.columns.push(colorColumn);

        // Column for displaying the budget percentage
        var budgetColumn = new wijmo.grid.Column();
        budgetColumn.binding = "budget";
        budgetColumn.header = "  ";
        budgetColumn.width = 100;
        budgetColumn.allowSorting = false;
        budgetColumn.isReadOnly = false;
        budgetColumn.align = "Right";
        distributionGrid.columns.push(budgetColumn);

        var totalQuantityColumn = new wijmo.grid.Column();
        totalQuantityColumn.binding = "totalQuantity";
        totalQuantityColumn.header = "#";
        totalQuantityColumn.allowSorting = false;
        totalQuantityColumn.width = "2*";
        totalQuantityColumn.allowSorting = false;
        totalQuantityColumn.isReadOnly = true;
        totalQuantityColumn.align = "Right";
        distributionGrid.columns.push(totalQuantityColumn);

        var sizeVariants = getSizeVariants(vm.selectedArticle);

        _.forEach(sizeVariants, function(sizeVariant) {
            var c = new wijmo.grid.Column();
            c.binding = sizeVariant.variantDetailName;
            c.header = sizeVariant.variantDetailName;
            c.width = "2*";
            c.allowSorting = false;
            c.inputType = 'text';
            c.isReadOnly = false;
            distributionGrid.columns.push(c);
        });

        var rowTotalColumn = new wijmo.grid.Column();
        rowTotalColumn.binding = "rowTotal";
        rowTotalColumn.header = "    ";
        rowTotalColumn.allowSorting = false;
        rowTotalColumn.width = "*";
        rowTotalColumn.allowSorting = false;
        rowTotalColumn.isReadOnly = true;
        distributionGrid.columns.push(rowTotalColumn);
    }

    // Populate the grid with data from the purchaseOrder
    function setupGridData() {
        rowData.length = 0;
        var sizeVariants = getSizeVariants(vm.selectedArticle);
        var locationsToProcess = [];

        if (vm.purchaseOrder.id !== undefined && vm.purchaseOrder.id !== 0) {
            _.forEach(vm.purchaseOrder.orders, function(order) {
                if (!_.find(locationsToProcess, function (addedLocation) { return addedLocation.id === order.destination.id; })) {
                    locationsToProcess.push(order.destination);
                }
            });
        } else {
            locationsToProcess = vm.locations;
        }

        // Adding one row element to be used as the size distribution weight row.
        var rw = {
            isDistributionRowElement: true
        };
        _.forEach(sizeVariants, function(sizeVariant) {
            rw[sizeVariant.variantDetailName] = 0;
        });
        rw['rowTotal'] = 0;
        rowData.push(rw);

        _.forEach(locationsToProcess, function(location) {
            var r = {};

            r['locationId'] = location.id;
            r['locationName'] = location.locationNumber + " " + location.locationName;
            r['colorName'] = vm.selectedColorVariant.variantDetailName;
            r['articleName'] = vm.selectedArticle.articleName;
            r['variantDetail1Id'] = vm.selectedColorVariant.id;
            r['budget'] = 0;
            r['totalQuantity'] = 0;
            r['rowTotal'] = 0;

            var foundOrder = _.find(vm.purchaseOrder.orders, function(order) {
                return order.destination.id === location.id;
            });
            _.forEach(sizeVariants, function(sizeVariant) {
                var foundRow;
                if (foundOrder) {
                    var foundOrderArticle = _.find(foundOrder.orderArticles, function(orderArticle) {
                        return orderArticle.article.id === vm.selectedArticle.id;
                    });
                    if (foundOrderArticle) {
                        foundRow = _.find(foundOrderArticle.orderRows, function(orderRow) {
                            return orderRow.articleVariant.variantDetail2.variantDetailName === sizeVariant.variantDetailName &&
                                    orderRow.articleVariant.variantDetail1.variantDetailName === vm.selectedColorVariant.variantDetailName;
                        });
                    }
                }

                r[sizeVariant.variantDetailName] = (foundRow) ? foundRow.quantity : 0;
                r[sizeVariant.variantDetailName + "ArticleVariant"] = (foundRow) ? foundRow.articleVariant : null;
            });
            rowData.push(r);
        });

        // Adding one row element to be used to display the totals of each column.
        var totalsRow = {
            isTotalsRowElement: true
        };
        _.forEach(sizeVariants, function(sizeVariant) {
            totalsRow[sizeVariant.variantDetailName] = 0;
        });
        totalsRow['rowTotal'] = 0;
        rowData.push(totalsRow);
    }

    // Do things when the user have edited a cell
    function cellEditEnded() {
        updateLocalPurchaseOrder();
    }

    function updateLocalPurchaseOrder() {
        writeUpdatesToPurchaseOrder();
        recalculateDistributionGridTotals();
        vm.onPurchaseOrderChanged({purchaseOrder: vm.purchaseOrder});
    }

    // Write the distribution grid data back to the purchaseOrder
    function writeUpdatesToPurchaseOrder() {
        _.forEach(rowData, function(row) {
            if (row.isDistributionRowElement || row.isTotalsRowElement) {
                return;
            }

            var order = _.find(vm.purchaseOrder.orders, function(order) {
                return order.destination.id === row.locationId;
            });

            var orderArticle = _.find(order.orderArticles, function(orderArticle) {
                return orderArticle.article.id === vm.selectedArticle.id;
            });

            var sizeVariants = getSizeVariants(vm.selectedArticle);

            _.forEach(sizeVariants, function(sizeVariant) {
                var orderRow = _.find(orderArticle.orderRows, function(orderRow) {
                    return orderRow.articleVariant.variantDetail1.id === vm.selectedColorVariant.id &&
                           orderRow.articleVariant.variantDetail2.id === sizeVariant.id;
                });

                if (orderRow === undefined) {
                    var artVar = _.find(vm.selectedArticle.articleVariants, function(articleVariant) {
                        return articleVariant.variantDetail1.id === vm.selectedColorVariant.id &&
                               articleVariant.variantDetail2.id === sizeVariant.id;
                    });

                    orderRow = newOrderRow(artVar);

                    if (orderArticle.orderRows === undefined) {
                        orderArticle.orderRows = [];
                    }

                    orderArticle.orderRows.push(orderRow);
                }

                orderRow.quantity = row[sizeVariant.variantDetailName];
            });
        });
    }

    // Calculate the row totals and column totals
    function recalculateDistributionGridTotals() {
        var columnTotalsRow = _.find(rowData, function(colorRow) {
            return colorRow.isTotalsRowElement;
        });

        // Calculate column totals.
        var sizeVariants = getSizeVariants(vm.selectedArticle);
        _.forEach(sizeVariants, function(sizeVariant) {
            var columnQuantity = 0;
            _.forEach(rowData, function(colorsRow) {
                if (!colorsRow.isDistributionRowElement && !colorsRow.isTotalsRowElement) {
                    columnQuantity += colorsRow[sizeVariant.variantDetailName];
                }
            });

            columnTotalsRow[sizeVariant.variantDetailName] = columnQuantity;
        });

        // Calculate row totals.
        _.forEach(rowData, function(row) {
            if (!rowData.isTotalsRowElement) {
                var rowQuantity = 0;
                _.forEach(sizeVariants, function(sizeVariant) {
                    rowQuantity += row[sizeVariant.variantDetailName];
                });
                row['rowTotal'] = rowQuantity;
            }
        });

        distributionGrid.invalidate();
        rowCollection.refresh();
    }

    // Get all unique variantDetail2s from provided article
    function getSizeVariants(article) {
        var sizeVariants = [];
        _.forEach(article.articleVariants, function(articleVariant) {
            if (!_.find(sizeVariants, {id: articleVariant.variantDetail2.id})) {
                sizeVariants.push(articleVariant.variantDetail2);
            }
        });

        return _.sortBy(sizeVariants, 'sortOrder');
    }

    // Get all unique variantDetail1s from provided article
    function getColorVariants(article) {
        var colorVariants = [];
        _.forEach(article.articleVariants, function(articleVariant) {
            if (!_.find(colorVariants, {id: articleVariant.variantDetail1.id})) {
                colorVariants.push(articleVariant.variantDetail1);
            }
        });

        return _.sortBy(colorVariants, 'sortOrder');
    }

    // Configures grid highlighting/formatting of certain cells
    function configureGridItemsFormatter() {
        distributionGrid.itemFormatter = function(panel, r, c, cell) {
            var style = cell.style;
            var regularCellType = wijmo.grid.CellType.Cell;

            if (((r === 0 && c > 3 && c < (distributionGrid.columns.length - 1)) || (c === 2)) && panel.cellType === regularCellType) {
                style.color = highlightForeGroundColor;
                style.backgroundColor = highlightBackgroundColor;
            }

            if ((r === (rowData.length - 1) && c > 3 || c === (distributionGrid.columns.length - 1)) && panel.cellType === regularCellType) {
                style.fontWeight = 'bolder';
                style.backgroundColor = summaryCellBackgroundColor;
            }
        };
    }

    // Distributes the quantity defined in vm.totalQuantityToDistribute over the quantity grid cells
    function distributeBudgetQuantities() {
        var totalDistributionQuantity = 0;
        var totalSizesDistributionQuantity = 0;

        var totalsSizesRowElement = _.find(rowData, {isDistributionRowElement: true});
        var totalsSizesRowElementKeys = _.without(Object.keys(totalsSizesRowElement), 'isDistributionRowElement');
        totalsSizesRowElementKeys = _.without(totalsSizesRowElementKeys, 'rowTotal');

        // Calculate total 'budget'
        _.forEach(rowData, function(row) {
            if (!row.isDistributionRowElement && !row.isTotalsRowElement) {
                totalDistributionQuantity += row.budget;
            }
        });

        // Set the row quantity distribution
        _.forEach(rowData, function(row) {
            if (!row.isDistributionRowElement && !row.isTotalsRowElement) {
                row['totalQuantity'] = Math.floor(vm.totalQuantityToDistribute * (row['budget'] / totalDistributionQuantity));
            }
        });

        // Get the full sum, to be used in the weighted ratio calculation below
        _.forEach(totalsSizesRowElementKeys, function(key) {
            totalSizesDistributionQuantity += totalsSizesRowElement[key];
        });

        // To prevent division by zero
        if (totalSizesDistributionQuantity === 0) {
            return;
        }

        // Set the size variant column quantities
        _.forEach(totalsSizesRowElementKeys, function(key) {
            if (key !== 'isDistributionRowElement') {
                _.forEach(rowData, function(row) {
                    if (!row.isDistributionRowElement && !row.isTotalsRowElement) {
                        row[key] = Math.floor(row['totalQuantity'] * (totalsSizesRowElement[key] / totalSizesDistributionQuantity));
                    }
                });
            }
        });

        updateLocalPurchaseOrder();
        distributionGrid.invalidate();
        rowCollection.refresh();
    }

    // Fetches the budget for each location, for the selected collection, for the currently selected article.
    function getAndApplyBudget() {
        BudgetsApiService.getBudgetsForItemGroupAndCollection(vm.selectedArticle.itemGroup.id, vm.purchaseOrder.articleCollection.id).then(function (response) {
            vm.budgets = response.data;
            setGridBudgetValues();
            var selectedPack = vm.selectedPack;
            var distributionRow = _.find(rowData, { isDistributionRowElement: true });
            var sizeVariants = getSizeVariants(vm.selectedArticle);
            if (selectedPack.id) {
                _.forEach(selectedPack.packArticleVariants, function(packArticleVariant) {
                    distributionRow[packArticleVariant.variantDetail.variantDetailName] = packArticleVariant.amount;
                });
            } else {
                _.forEach(sizeVariants, function(sizeVariant) {
                    distributionRow[sizeVariant.variantDetailName] = 1;
                });
            }
        }, function(error) {
            // TODO: toasterservice here
            console.log(error);
        });
    }

    // Populate the budget fields with the appropriate data
    function setGridBudgetValues() {
        _.forEach(vm.budgets, function(budget) {
            var rd = _.find(rowData, function(row) {
                return row.locationId === budget.location.id;
            });
            if (rd) {
                rd.budget = budget.purchaseCost;
            }
        });

        distributionGrid.invalidate();
        rowCollection.refresh();
    }

    function getArticlePacks() {
        OrdersApiService.getPacksForArticle(vm.selectedArticle.id).then(function(response) {
            vm.packs = response;
        }, function(error) {
            // TODO: toasterservice here
            console.log(error);
        });
    }

    function newOrderRow(articleVariant) {
        var supplierPrice = _.find(articleVariant.supplierPrices, function(supplierPrice) {
            return supplierPrice.companyId === vm.purchaseOrder.company.id;
        });

        var purchaseCost = (supplierPrice !== undefined) ? supplierPrice.purchasePrice : articleVariant.purchaseCost;

        return {
            id: 0,
            orderStatus: {},
            articleVariant: articleVariant,
            purchaseCost: purchaseCost
        };
    }
}
